<div class="loader" *ngIf="loading else main">
    <!-- <core-helpers-box-loading></core-helpers-box-loading> -->
    <div class="dimmed">
        <div class="dimmed_title"></div>
        <div class="dimmed_sub_box">
            <div class="dimmed_subtitle"></div>
        </div>
    </div>
</div>
<ng-template #main>
    <div class="providers-sso-main">
        <div class="sso-options" >
            <!--
            <div class="multiple">
                <span title="Microsoft Azure" class="login-sso-azure" (click)="onSoo('azure')"><em>Azure</em></span>
                <span title="Google" class="login-sso-google" (click)="onSoo('google')"><em>Google</em></span>
            </div>
            -->
            <div class="single">
                <span title="Google" class="login-sso-google" (click)="onSoo('google')"><em>Google</em></span>
            </div> 
        </div>
    </div>
    <core-helpers-box-card *ngIf="error" [title]="'SSO failed'" [text]="'There was an error with sign on procedure.'"></core-helpers-box-card>
</ng-template>
